module.exports = __webpack_public_path__ + "static/11-d98be30ecb3f76fd32e018ea96951c63.png";